import { editCategory } from 'actions/bulkOutcomes';
import LinkLookup from 'components/LinkLookup';
import React from 'react';
import { useDispatch } from 'react-redux';
import type { Category, Outcome, RuleRevision } from 'types';

interface Props {
  category: Category;
  rule: RuleRevision;
  selected: boolean;
  setSelectedCategories: React.Dispatch<React.SetStateAction<string[]>>;
}

const CategoryListItem: React.VFC<Props> = ({
  rule,
  category,
  selected,
  setSelectedCategories,
}) => {
  const dispatch = useDispatch();
  const { uuid, outcome, config } = category;
  const { uuid: outcomeId, name, type } = outcome as Outcome;

  const handleCategorySelect = (checked: boolean): void => {
    if (checked) {
      setSelectedCategories((prev) => [...prev, uuid]);
    } else {
      setSelectedCategories((prev) => prev.filter((id) => id !== uuid));
    }
  };

  const handleRowCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    e.stopPropagation();
    handleCategorySelect(e.target.checked);
  };

  const handlePlatformChange = (e: React.ChangeEvent<HTMLInputElement>, p: string): void => {
    e.stopPropagation();

    dispatch(
      editCategory({
        category: { ...category, config: { ...category.config, [p]: e.target.checked } },
        ruleId: category.rule?.rule_group_uuid || '',
      })
    );
  };

  const platform = {
    active_o365_teams: 'Microsoft Teams',
    active_slack: 'Slack',
    active_gmail: 'Gmail',
    active_chrome: 'Chrome',
    active_glia: 'Glia',
    active_o365: 'Microsoft O365',
    active_inbound: 'Inbound',
  };

  return (
    <LinkLookup
      key={uuid}
      as="tr"
      className="border-t border-gray-200 hover:bg-gray-100 table-row h-10"
      routeName="rule-group-outcome-id"
      routeParams={{ ruleId: rule.rule_group_uuid, outcomeId }}
    >
      <td className="table-wrapper__new-td flex w-full">
        <div className="w-full pt-2.5 px-2 min-h-8 flex justify-end">
          <input
            id={`checkbox-user-${uuid}`}
            data-testid={`checkbox-${uuid}`}
            type="checkbox"
            className="cursor-pointer form-checkbox litlingo-checkbox w-5 h-5"
            onClick={(e): void => e.stopPropagation()}
            onChange={(e): void => {
              handleRowCheckboxChange(e);
            }}
            checked={selected}
          />
        </div>
      </td>
      <td className="table-wrapper__new-td">
        <div className="flex flex-row items-start gap-1 py-2.5 pr-4 text-body">
          <div className="flex overflow-hidden">
            <div className="">{name}</div>
          </div>
        </div>
      </td>
      <td className="table-wrapper__new-td">
        <div className="flex flex-row items-start gap-1 pr-4 text-body">
          <div className="flex overflow-hidden">
            <div className="">{type}</div>
          </div>
        </div>
      </td>
      {Object.keys(platform).map((p) => (
        <td key={p} className="table-wrapper__new-td">
          <div className="flex flex-row items-start gap-1 pr-4 text-body">
            <input
              id={`checkbox-user-${p}`}
              data-testid={`checkbox-${p}`}
              type="checkbox"
              className="cursor-pointer form-checkbox litlingo-checkbox w-5 h-5"
              onClick={(e): void => e.stopPropagation()}
              onChange={(e): void => {
                handlePlatformChange(e, p);
              }}
              checked={!!config[p as keyof Category['config']]}
            />
          </div>
        </td>
      ))}
    </LinkLookup>
  );
};

export default CategoryListItem;
